import {Button, ButtonGroup, Form, FormCheck} from "react-bootstrap";
import {useState} from "@hookstate/core";
import {Redirect} from 'react-router-dom';

import './NewClient.scss';
import ClientAddress from "./Components/ClientAddress";
import ClientContact from "./Components/ClientContact";
import {createNewClient, pingAPI} from "../../Services/ApiService";
import {useEffect} from "react";

function NewClient() {
    const apiError = useState(false);
    const redirect = useState(null);
    const client = useState({
        name: '',
        isTaxExempt: false,
        addresses: [{
            id: 0,
            street: '',
            street2: '',
            city: '',
            state: '',
            zip: ''
        }],
        contacts: [{
            id: 0,
            name: '',
            phone: '',
            email: ''
        }],
        salesman: ''
    });
    const warnings = useState({clientName: ''});
    const message = useState("");

    useEffect(() => {
        pingAPI(response => {if (response === false) return apiError.set(true)});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function onClientNameChange(e) {
        if (e.target.value === '') {
            warnings.clientName.set('Cannot be blank');
        } else {
            warnings.clientName.set('');
        }
        client.name.set(e.target.value);
    }

    function addAddress() {
        client.addresses[client.addresses.length].set({
                id: client.addresses.get()[client.addresses.get().length - 1].id + 1,
                street: '',
                street2: '',
                city: '',
                state: '',
                zip: ''
        });
    }

    function removeAddress(e) {
        client.addresses.set(JSON.parse(JSON.stringify(client.get().addresses.filter(address => {
            return address.id.toString() !== e.target.id.toString();
        }))));
    }

    function addContact() {
        client.contacts[client.contacts.length].set({
            id: client.contacts.get()[client.contacts.get().length - 1].id + 1,
            name: '',
            phone: '',
            email: '',
        });
    }

    function removeContact(e) {
        client.contacts.set(JSON.parse(JSON.stringify(client.get().contacts.filter(contact => {
            return contact.id.toString() !== e.target.id.toString();
        }))));
    }

    function handleSubmitClicked() {
        createNewClient(JSON.parse(JSON.stringify(client.get())), res => {
            if (!res.success) {
                message.set(res.message);
            } else {
                redirect.set(`/client/${res.message}/`);
            }
        });
    }

    if (apiError.get()) {
        return <h4>Unable to reach server.</h4>;
    }

    // noinspection JSValidateTypes
    return (
        <div id={'newClient'}>
            <Form className={'newClientForm'}>
                <div id={'clientNameDiv'}>
                    <h4>Client Name:</h4>
                    <Form.Control id={'clientName'}
                                  onChange={(e) => {onClientNameChange(e)}}
                                  value={client.get().name}
                    />
                </div>
                {(warnings.get().clientName !== '') && <div className={'formError'}>{warnings.get().clientName}</div>}

                <div id={'salesmanDiv'}>
                    <p>Default Salesman:</p>
                    <Form.Control id={'salesman'}
                                  onChange={(e) => {client.salesman.set(e.target.value)}}
                                  value={client.get().salesman}
                    />
                </div>

                <FormCheck id={'isTaxExempt'}
                           onChange={e => client.isTaxExempt.set(e.target.checked)}
                           checked={client.get().isTaxExempt}
                           label={"Tax Exempt"} />


                <hr />

                <h4>Addresses:</h4>
                {client.addresses.get().map((address, idx) => {
                    // noinspection JSValidateTypes
                    return (
                        <div key={idx} className={'arrayWrapper'}>
                            <ClientAddress addresses={client.addresses} index={idx} />
                            <ButtonGroup vertical className={'clientAddressButtons'}>
                                <Button onClick={addAddress}>+</Button>
                                <Button onClick={removeAddress}
                                        id={address.id}
                                        disabled={client.addresses.get().length < 2}>-</Button>
                            </ButtonGroup>
                        </div>
                    )
                })}
                <hr />

                <h4>Contacts:</h4>
                {client.contacts.get().map((contact, idx) => {
                    // noinspection JSValidateTypes
                    return (
                        <div key={idx} className={'arrayWrapper'}>
                            <ClientContact contacts={client.contacts} index={idx} />
                            <ButtonGroup vertical className={'contactsButtons'}>
                                <Button onClick={addContact}>+</Button>
                                <Button onClick={removeContact}
                                        id={contact.id}
                                        disabled={client.contacts.get().length < 2}>-</Button>
                            </ButtonGroup>
                        </div>
                    )
                })}
                <Button onClick={handleSubmitClicked}>Submit</Button>
                <p id={"message"} className={"alert-danger"}>{message.get()}</p>
            </Form>
            {redirect.get() && <Redirect to={redirect.get()} />}
        </div>
    )
}

export default NewClient;